/* Refillia: hero in movimento e ricerca che si scrive da sola nelle card della home */
(function () {
  var calma = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function hero(el) {
    if (el.dataset.rfhmPronta) return;
    el.dataset.rfhmPronta = '1';
    var flaconi = el.querySelectorAll('[data-rfhm-prodotto]');
    if (!flaconi.length) return;
    var parole = el.querySelectorAll('[data-rfhm-parole] span');
    var barre = el.querySelectorAll('.rfhm__barre i');
    var eti = el.querySelector('[data-rfhm-etichetta]');
    var cifra = el.querySelector('[data-rfhm-cifra]');
    var formato = el.querySelector('[data-rfhm-formato]');
    var nome = el.querySelector('[data-rfhm-nome]');
    var tipo = el.querySelector('[data-rfhm-tipo]');
    var tempo = parseInt(el.dataset.tempo, 10) || 3400;
    el.style.setProperty('--rfhm-tempo', tempo + 'ms');
    var n = -1, timer = null;

    function conta(fino) {
      if (calma) { cifra.textContent = euro(fino); return; }
      var t0 = null;
      function passo(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 700);
        cifra.textContent = euro(Math.round(fino * (1 - Math.pow(1 - k, 3))));
        if (k < 1) requestAnimationFrame(passo);
      }
      requestAnimationFrame(passo);
    }

    function prossimo() {
      var prima = n;
      n = (n + 1) % flaconi.length;
      var f = flaconi[n];
      if (prima >= 0) { flaconi[prima].classList.remove('dentro'); flaconi[prima].classList.add('fuori'); }
      eti.classList.remove('dentro');
      parole.forEach(function (s, i) { s.className = i === n ? 'su' : (s.className === 'su' ? 'via' : ''); });
      setTimeout(function () {
        if (prima >= 0) flaconi[prima].classList.remove('fuori');
        f.classList.add('dentro');
        nome.textContent = f.dataset.nome;
        tipo.innerHTML = '';
        if (f.dataset.tipo) { tipo.appendChild(document.createTextNode(f.dataset.tipo + ' ')); }
        var s = document.createElement('span'); s.textContent = (f.dataset.tipo ? '· ' : '') + f.dataset.nome; tipo.appendChild(s);
        formato.textContent = f.dataset.formato;
        formato.hidden = !f.dataset.formato;
        eti.classList.add('dentro');
        setTimeout(function () { conta(parseInt(f.dataset.prezzo, 10) || 0); }, 380);
      }, prima >= 0 ? 380 : 60);
      barre.forEach(function (b, i) { b.className = i < n ? 'fatto' : (i === n ? 'ora' : ''); });
    }

    function parti() { if (!timer && !calma && flaconi.length > 1) timer = setInterval(prossimo, tempo); }
    function ferma() { clearInterval(timer); timer = null; }
    prossimo();
    // gira solo quando si vede
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (voci) { voci[0].isIntersecting ? parti() : ferma(); }).observe(el);
    } else { parti(); }
  }

  function cerca(el) {
    if (el.dataset.rfTrovaPronta) return;
    el.dataset.rfTrovaPronta = '1';
    var voci = [];
    try { voci = JSON.parse(el.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    if (!voci.length) return;
    var scr = el.querySelector('[data-rf-scrive]'), es = el.querySelector('[data-rf-esito]'), ic = 0;
    var foto = es.querySelector('.rf-trova__foto img'), nome = es.querySelector('.rf-trova__nome b'),
      sotto = es.querySelector('.rf-trova__nome span'), prezzo = es.querySelector('em');
    function riempi(c) {
      if (foto) foto.src = c.img;
      if (nome) nome.textContent = c.nome;
      if (sotto) sotto.textContent = c.sotto;
      if (prezzo) prezzo.textContent = c.prezzo;
    }
    // la scritta gira solo mentre la card si vede: fuori schermo non consuma
    var visibile = true, fermo = false;
    function giro() {
      if (!visibile) { fermo = true; return; }
      var c = voci[ic % voci.length], i = 0; ic++;
      es.classList.remove('si');
      if (calma) { scr.textContent = c.q; riempi(c); es.classList.add('si'); return; }
      scr.textContent = '';
      var t = setInterval(function () {
        scr.textContent = c.q.slice(0, ++i);
        if (i >= c.q.length) {
          clearInterval(t);
          setTimeout(function () { riempi(c); es.classList.add('si'); }, 250);
          setTimeout(giro, 3200);
        }
      }, 55);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        visibile = e[0].isIntersecting;
        if (visibile && fermo) { fermo = false; giro(); }
      }).observe(el);
    }
    giro();
  }

  function avvia(radice) {
    (radice || document).querySelectorAll('[data-rfhm]').forEach(hero);
    (radice || document).querySelectorAll('[data-rf-trova]').forEach(cerca);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { avvia(); });
  else avvia();
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();
